import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const TextEditor = ({ onContentChange }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    // Convert editor content to HTML
    const rawContentState = convertToRaw(newEditorState.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState, {
      trigger: "#", // Allow raw HTML like iframe
      options: {
        iframe: true,
      },
    });
    onContentChange(htmlContent);
  };



  return (
    <div className="bg-black ">
      <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName "
        editorClassName="editorClassName text-white"
        onEditorStateChange={onEditorStateChange}
        
      />
    </div>
  );
};

export default TextEditor;